import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "@fontsource/lato";
import "@fontsource/lato/300.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";
import UserDataProvider from "./hooks/userDataProvider";
import AppRoutes from "./routes";

const theme = createTheme({
    typography: {
        fontFamily: '"Lato", sans-serif',
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <UserDataProvider>
                    <AppRoutes />
                </UserDataProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;
